module.exports = __webpack_public_path__ + "assets/img/2-2.959d4462.png";